import CommonApi from './../commonApi';
const regulation = Object.assign(
  new CommonApi('regulation', 'регламент НТС'),
  {
    changeStatus: new CommonApi(
      'regulation/changeStatus',
      'смена статуса регламента НТС'
    )
  }
);
export default regulation;
